import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

import board_cast from '@common/BoardCast';

import { DatePicker, Row, Col, Input, Select } from 'antd';

import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";

import my_rake_back_store, { pagination_store, filter_store } from '@store/Statistic/MyRakeBack/MyRakeBackStore';


@observer
class MyRakeBackFilterForm extends React.Component  {
  render () {

    let numberStyle = {
      fontSize:'22px',
      fontWeight: '700',
      marginLeft: '30px',
      float: 'right'
    };
    let tipStyle = {
      marginLeft:'10px',
      float: 'right'
    };

    return (
      <Row type="flex" justify="end" style={{flex: 1}}>
        <Col>
          <MySearchComponent
            defaultValue={{
              agent:filter_store.agent?filter_store.agent:'',
              typeMode:CustomerTypeSelect.TYPE_MODE_AGENT,
              type:CustomerTypeSelect.getTypeName(CustomerTypeSelect.TYPE_MODE_AGENT,filter_store.type),
              search:filter_store.search?filter_store.search:'',
              date:filter_store.start_time != undefined?[filter_store.start_time,filter_store.end_time]:[]
            }}
            onClick={(values)=> {
              board_cast.emit('closeAllExpanded');
              let agent = values.agent;

              if (agent == '')
              {
                agent = undefined
              }

              let search = values.search;

              if (search == '')
              {
                search = undefined;
              }

              let filter = {
                agent:agent,
                type:2,
                search:search,
                type_time:values.type_time || 6,
              }

              my_rake_back_store.reloadDatas(filter);

            }}
          />
        </Col>
        <Col style={{
          lineHeight: '35px',
          marginLeft: '15px',
          flex: 1
        }}>
          <span style={numberStyle}>{Number(my_rake_back_store.summoney).toFixed(2)}</span>
          <span style={tipStyle}>总投注</span>
        </Col>
      </Row>
    )
  }
}



export default MyRakeBackFilterForm;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/MyRakeBack/MyRakeBackFilterForm.jsx